<script>
import StrOccupationDataTableSelect from "@/components/StrOccupationDataTableSelect.vue";
import PaySectionSelection from "@/components/PaySectionSelection.vue";
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import {ref} from "vue";
import axios from "axios";

export default {
    components: {
        PaySectionSelection,
        StrOccupationDataTableSelect,
    },
    props: {
        addAction: Boolean,
        deleteAction: Boolean,
    },
    setup(props) {
        const {loading, dialog} = useSharedData();
        const {getBack} = useSharedMethod();
        
        const erase = ref(false);
        const paySections = ref([]);
        
        const filter = ref({
            paySectionId: [],
        });
        const selectedOccupation = ref([]);
        
        function save() {
            loading.value = true;
            const ids = selectedOccupation.value.map(element => element.id);
            const body = {
                ids: ids,
                paySections: paySections.value,
            };
            filter.value.paySectionIds = filter.value.paySectionId.toString();
            filter.value.erase = erase.value;
            const url = props.addAction ? "addPaySections" : "removePaySections";
            axios.put(`/occupations/${url}`, body, {
                params: filter.value,
            }).then(() => {
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function updateSelectedOccupation(items) {
            selectedOccupation.value = items;
        }
        
        function updateFilter(item) {
            filter.value = item;
        }
        
        function updatePaySection(items) {
            paySections.value = items;
        }
        
        return {
            loading,
            dialog,
            erase,
            paySections,
            filter,
            selectedOccupation,
            updateSelectedOccupation,
            updateFilter,
            updatePaySection,
            save,
            getBack,
        }
    }
};
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        scrollable
        persistent
        max-width="1600"
    >
        <v-card flat>
            <w-toolbar v-if="addAction" color="teal" :title="$t('common.add_pay_sections')"/>
            <w-toolbar v-if="deleteAction" color="red" :title="$t('common.delete_pay_sections')"/>
           <v-card-text>
                <v-container fluild>
                    <v-row>
                        <v-col cols="5">
                            <pay-section-selection
                                :initial-pay-section-selection="paySections"
                                by-occupation
                                :pay-preview="false"
                                @updatePaySection="updatePaySection"
                            />
                            <br/><br/>
                            <v-alert
                                class="ma-1"
                                text
                                dense
                                color="teal"
                                icon="mdi-clock-fast"
                                border="left"
                                v-if="selectedOccupation.length === 0"
                            >
                                {{ $t("common.occupation_select_description") }}
                            </v-alert>
                        </v-col>
                        <v-col cols="7">
                            <str-occupation-data-table-select
                                @updateSelectedOccupation="updateSelectedOccupation"
                                @updateFilter="updateFilter"
                            ></str-occupation-data-table-select>
                        </v-col>
                    </v-row>
                </v-container>
            
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-radio-group
                    v-if="addAction"
                    v-model="erase"
                    row
                    class="ma-0 pa-0"
                    hide-details
                >
                    <template v-slot:label>
                        {{ $t('pay_slip.if_pay_section_exist') }}
                    </template>
                    <v-radio
                        :label="$t('common.keep')"
                        :value="false"
                        color="teal"
                    />
                    <v-radio
                        :label="$t('common.replace')"
                        :value="true"
                        color="red"
                    />
                </v-radio-group>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-add
                    :show="addAction"
                    :loading="loading"
                    @press="save(false)"
                />
                <w-btn-update
                    :show="updateAction"
                    :loading="loading"
                    @press="update"
                />
                <w-btn-delete
                    :show="deleteAction"
                    :loading="loading"
                    @press="save"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>